export const convertFuelPrice = price => {
  // Convert cents to dollars and ensure proper decimal formatting
  const dollarAmount = price / 100;
  // Return the value with 2 decimal places to ensure proper display
  return dollarAmount.toFixed(2);
};
